import { CONTROLS_ROWS } from './types';
import './styles.css';

/** Pure UI: Settings → Controls (static binding table). */
export function ControlsTabInterface() {
  return (
    <div className="settings-controls">
      <p className="settings-controls__intro">Desktop and mobile bindings for the current build.</p>
      <table className="settings-controls__table">
        <thead>
          <tr>
            <th scope="col">Action</th>
            <th scope="col">Input</th>
          </tr>
        </thead>
        <tbody>
          {CONTROLS_ROWS.map((row) => (
            <tr key={row.action}>
              <td>{row.action}</td>
              <td>
                <code>{row.binding}</code>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
